import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetEntitledAccountsQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
  searchQuery?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  selectedAccountId?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
}>;

export type GetEntitledAccountsQueryResult = { __typename?: 'Query' } & {
  entitledAccounts?: GraphQLTypes.Maybe<
    { __typename?: 'EntitledAccountsPayload' } & {
      account?: GraphQLTypes.Maybe<
        { __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'organizationalRole' | 'tradingName'>
      >;
      businessUnits: Array<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'organizationalRole' | 'tradingName'>>;
      managed: Array<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'organizationalRole' | 'tradingName'>>;
    }
  >;
};

export const GetEntitledAccountsDocument = gql`
  query getEntitledAccounts($accountId: String!, $searchQuery: String, $selectedAccountId: String) {
    entitledAccounts(accountId: $accountId, searchQuery: $searchQuery, selectedAccountId: $selectedAccountId) {
      account {
        id
        organizationalRole
        tradingName
      }
      businessUnits {
        id
        organizationalRole
        tradingName
      }
      managed {
        id
        organizationalRole
        tradingName
      }
    }
  }
`;
